import { newPermissions } from '@shared/newPermissions';

import BulkMBCAssignPageContainer from './mbcBulkAssign/components/BulkMBCAssignPage';
import { ROUTE_MBC_BULK_ASSIGN } from './mbcBulkAssign/duck/actions';
import BulkMBCEntryPage from './mbcBulkEntry/components/BulkMBCEntryPage';
import { ROUTE_MBC_BULK_ENTRY } from './mbcBulkEntry/duck/actions';
import ClassEntryPage from './mbcClassEntry/components/ClassEntryPageContainer';
import { ROUTE_MBC_CLASS_ENTRY } from './mbcClassEntry/duck/actions';
import MBCDashboardPage from './mbcDashboard/components/MBCDashboardPage';
import { ROUTE_MBC_DASHBOARD } from './mbcDashboard/duck/actions';
import { ROUTE_MBC_SEARCH } from './mbcSearch/actions';
import { MBCSearchPage } from './mbcSearch/components/MBCSearchPage';

const mbcPermissions = newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE;

const routes = {
  [ROUTE_MBC_SEARCH]: {
    path: '/meritBadgeCounselors',
    Component: MBCSearchPage,
    titleId: 'page.meritBadgeCounselors',
    permission: mbcPermissions,
  },
  [ROUTE_MBC_BULK_ASSIGN]: {
    path: '/meritBadgeCounselors/bulk-assign',
    Component: BulkMBCAssignPageContainer,
    titleId: 'page.mbcBulkAssign',
    permission: newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE,
  },
  [ROUTE_MBC_BULK_ENTRY]: {
    path: '/meritBadgeCounselors/bulk-entry',
    Component: BulkMBCEntryPage,
    titleId: 'page.mbcBulkEntry',
    permission: [
      newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE,
      newPermissions.VIEW_MBC_DASHBOARD,
    ],
  },
  [ROUTE_MBC_CLASS_ENTRY]: {
    path: '/meritBadgeCounselors/class-entry',
    Component: ClassEntryPage,
    titleId: 'page.mbcClassEntry',
    permission: [
      newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE,
      newPermissions.VIEW_MBC_DASHBOARD,
    ],
  },
  [ROUTE_MBC_DASHBOARD]: {
    path: '/meritBadgeCounselors/dashboard',
    Component: MBCDashboardPage,
    titleId: 'page.mbcDashboard',
    permission: [
      newPermissions.VIEW_MERIT_BADGE_COUNSELORS_PAGE,
      newPermissions.VIEW_MBC_DASHBOARD,
    ],
  },
};

export default routes;
